<template>
  <v-container>
    <v-card class="d-flex flex-column-reverse flex-md-row justify-space-between" flat tile>
      <v-row class="pa-4" align="center" justify="center" no-gutters>
        <v-card class="pa-4" flat tile width="500">
          <v-img :src="require('../assets/layer.png')" contain> </v-img>
          <div class="pa-2">
            <p>
              Tasa de interés anual fija por ciclo 40% más IVA. CAT promedio del
              71% más IVA por un monto de $7,000 a 20 semanas. Para fines
              informativos y de comparación. Calculado del 01 de julio al 31 de diciembre de 2023.
              <a @click="modalComissions">Consulte comisiones aquí</a>.
            </p>
          </div>
        </v-card>
      </v-row>

      <v-row class="pa-4" align="center" justify="center" no-gutters>
        <v-card class="pa-4 aling" tile flat width="500">
          <v-col>
            <p class="mt-8 font-gotham primary--text">
              Con MetaFinanciera es muy fácil y rápido
            </p>

            <validation-observer ref="observer" v-slot="{ invalid }">
              <form @submit.prevent="sendForm" class="mt-5" id="FormularioGeneral">
                <validation-provider v-slot="{ errors }" name="El campo de nombre" rules="required">
                  <label for="name" class="mb-1 text-subtitle-1">Nombre</label>
                  <v-text-field color="secondary" dense :error-messages="errors" outlined placeholder="Ej. Alejandra"
                    ref="name" required v-model="leadInfo.nombre"></v-text-field>
                </validation-provider>
                <validation-provider v-slot="{ errors }" name="El teléfono celular" :rules="{
                  required: true,
                  digits: 10,
                }">
                  <label for="phone" class="mb-1 text-subtitle-1">Teléfono celular</label>
                  <v-text-field color="secondary" counter="10" dense :error-messages="errors" outlined
                    placeholder="Ej. 55 5031 4068" ref="phone" required type="number"
                    v-model="leadInfo.telefono"></v-text-field>
                </validation-provider>
                <validation-provider v-slot="{ errors }" rules="required" name="checkbox">
                  <v-checkbox color="primary" dense :error-messages="errors" required ripple type="checkbox"
                    v-model="accepted">
                    <template v-slot:label>
                      <div>
                        He leído y acepto los
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <a target="_blank" href="https://metafinanciera.com.mx/terminos-y-condiciones" @click.stop
                              v-on="on">
                              Términos y Condiciones
                            </a>
                          </template>
                          Términos y condiciones de Metafinanciera
                        </v-tooltip>
                        , así como las
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <a target="_blank" href="https://metafinanciera.com.mx/aviso-de-privacidad" @click.stop
                              v-on="on">
                              Políticas de Privacidad
                            </a>
                          </template>
                          Políticas de Privacidad de Metafinanciera
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </validation-provider>
                <v-btn color="accent" block type="submit" :disabled="invalid" :loading="loadingbtn">
                  Más información
                </v-btn>
              </form>
            </validation-observer>
          </v-col>
        </v-card>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import axios from "axios";
import config from "../../config";
import moment from "moment";
import { required, digits, email, max, regex } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

moment.locale("es-mx");

setInteractionMode("eager");

extend("digits", {
  ...digits,
  message: "{_field_} tiene que contener {length} dígitos.",
});

extend("required", {
  ...required,
  message: "{_field_} no puede estar vacío",
});

extend("max", {
  ...max,
  message: "{_field_} no puede contener más de {length} números",
});

extend("regex", {
  ...regex,
  message: "{_field_} no tiene un formato válido.",
});

extend("email", {
  ...email,
  message: "El correo electrónico tiene que ser válido",
});

export default {
  name: "Form",

  components: {
    ValidationProvider,
    ValidationObserver,
  },

  data: () => ({
    accepted: null,
    leadInfo: {
      nombre: "",
      telefono: "",
    },
    loadingbtn: false,
  }),
  methods: {
    modalComissions() {
      Swal.fire({
        imageUrl: require("../../public/metaLogo.svg"),
        imageWidth: 100,
        html: "<img />",
        showConfirmButton: false,
        width: 800,
        didOpen: () => {
          var img = Swal.getHtmlContainer().querySelector("img");
          img.src = require("../../public/comissions.png");
          img.style = "width: 700px";
        },
      });
    },
    clear() {
      for (var [key] of Object.entries(this.leadInfo)) this.leadInfo[key] = "";
      this.fullName = "";
      this.accepted = null;
      this.$refs.observer.reset();
    },
    async sendForm() {
      try {
        this.loadingbtn = true;

        let phone = this.leadInfo.telefono;
        let existsLead = await axios.post(
          `${config.validate}/existsLeads`,
          {
            phone,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
            },
          }
        );

        if (existsLead.data.code === 200) {
          let { existPhone, existEmail, existCurp } = existsLead.data.response;
          if (existPhone || existEmail || existCurp) {
            return await Swal.fire({
              title: "Lo sentimos",
              text: "Parece que ya has intentado hacer esta solicitud. Por favor, espera a que uno de nuestros agentes se ponga en contacto contigo.",
              icon: "info",
              confirmButtonText: "Entendido",
            }).then(() => (this.loadingbtn = false));
          } else {
            // * Servicio reducido
            let serviceBody = {
              ...this.leadInfo,
              submittedAt: `${moment(new Date()).format("x")}`,
              montoDelPrestamo: this.$store.state.amount * 1000,
              tycs: "true",
              fechaDeRegistro: `${moment().format("YYYY-MM-DD")}`,
            };

            console.log(serviceBody);
            let temp = await axios.post(`${config.insert}`, serviceBody, {
              headers: {
                "Content-Type": "application/json",
              },
            });

            let id = temp.data.response.id;

            await Swal.fire({
              icon: "success",
              title: "¡Hecho!",
              text: "Se ha enviado tu información",
              timer: 2000,
              showConfirmButton: false,
            }).then(() => {
              this.loadingbtn = false;
              let routeData = this.$router.resolve({
                path: `https://metafinanciera.com.mx/success?id=${id}`,
              });
              this.clear();
              window.open(
                routeData.href.slice(1, routeData.href.length),
                "_blank"
              );
            });
            this.clear();
          }
        } else {
          console.log(temp);
          await Swal.fire({
            title: "¡Ups!",
            text: "Algo salió mal. Intenta de nuevo más tarde.",
            icon: "error",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.loadingbtn = false;
    },
  },
};
</script>
<style scoped>
hr {
  margin: 1rem;
}
</style>
